/**
 * pwaChannel — BroadcastChannel for cross-tab / PWA synchronisation.
 *
 * When one tab mutates shared data (e.g. a new image is generated or deleted),
 * post a message so all other open tabs and the installed PWA window refresh.
 *
 * Usage:
 *   import { pwaChannel } from '@/utils/pwaChannel';
 *   pwaChannel?.postMessage({ type: 'GALLERY_UPDATED' });
 *
 * Listening (handled in index.tsx):
 *   window.addEventListener('pwa:gallery-updated', handler);
 */

const CHANNEL_NAME = 'paqshot-pwa';

export type PwaChannelMessage =
  | { type: 'GALLERY_UPDATED' }
  | { type: 'SW_UPDATED'; version: string };

let _channel: BroadcastChannel | null = null;

if (typeof BroadcastChannel !== 'undefined') {
  _channel = new BroadcastChannel(CHANNEL_NAME);
  _channel.addEventListener('message', (event: MessageEvent<PwaChannelMessage>) => {
    if (event.data?.type === 'GALLERY_UPDATED') {
      window.dispatchEvent(new CustomEvent('pwa:gallery-updated', { detail: event.data }));
    }
  });
}

export const pwaChannel: BroadcastChannel | null = _channel;
